import React from "react";

import "./style.scss";

const InputText = function ({
  name,
  value,
  onChange,
  readOnly,
  isPassword,
  placeholder,
  disabled,
}: {
  name: string;
  value: string;
  onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
  readOnly?: boolean;
  isPassword?: boolean;
  placeholder: string;
  disabled?: boolean;
}) {
  return (
    <input
      name={name ? name : ""}
      type={isPassword ? "password" : "text"}
      value={value}
      onChange={onChange}
      className="input-text"
      disabled={disabled ? true : false}
      readOnly={readOnly}
      placeholder={placeholder}
    />
  );
};

export default InputText;
